import load from "external-load";
import Component from "flarum/common/Component";
import app from "flarum/forum/app";
import type Mithril from "mithril";

let loaded = false;
const addResources = async () => {
    if (loaded) {
        return;
    }

    await load.js(
        "/assets/scripts/aplayer@1.10.1.min.js"
    );

    loaded = true;
};

export default class Player extends Component {
    
    constructor() {
        super();
    }

    oncreate(vnode: Mithril.VnodeDOM): void {
        super.oncreate(vnode);

        const allowGuests = app.forum.attribute("listenMoeRadioGuests");
        const radioUrl = app.forum.attribute("listenMoeRadioUrl");
        const user = app.session.user;

        if (!radioUrl || (!user && !allowGuests)) {
            return;
        }

        addResources().then(() => {
            const player = new APlayer({
                container: this.element,
                fixed: true,
                theme: "#4d698e",
                loop: "none",
                preload: "metadata",
                volume: 0.2,
                audio: {
                    name: "&nbsp;",
                    artist: "&nbsp;",
                    url: radioUrl,
                },
            });

            player.on("pause", () => window.player.shouldSync = true);

            player.on("play", () => {
                if (window.player.shouldSync) {
                    window.player.shouldSync = false;
                    player.audio.load();
                    player.audio.play();
                }
            });

            window.player = player;
        });
    }

    view(vnode: Mithril.VnodeDOM) {
        return <div id="radio-container" />;
    }
}
